import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { User, UserRole } from '@types/index';
import authService from '@services/authService';

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  
  setUser: (user: User | null) => void;
  login: (user: User) => void;
  logout: () => void;
  checkAuth: () => void;
}

/**
 * Authentication state store using Zustand
 */
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,
      isLoading: false,

      setUser: (user) => {
        set({ user, isAuthenticated: !!user });
      },

      login: (user) => {
        set({ user, isAuthenticated: true });
      },

      logout: async () => {
        try {
          await authService.logout();
        } catch (error) {
          // Even if logout fails, clear local state
          console.error('Logout error:', error);
        } finally {
          set({ user: null, isAuthenticated: false });
          // Navigate to login page
          window.location.href = '/login';
        }
      },

      checkAuth: () => {
        const isAuth = authService.isAuthenticated();
        const storedUser = authService.getStoredUser();
        
        set({
          isAuthenticated: isAuth,
          user: storedUser,
        });
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        user: state.user,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);


